<template>
	<div class="section-map primary--text">
		<v-img :src="ImageMap" />
		<!-- <p class="text-h3 my-5 text-center">Легенда карты</p> -->
		<div class="px-3 px-sm-5 pt-6 d-flex justify-space-between legend">
			<ol>
				<li>Русская игрушка</li>
				<li>Береста</li>
				<li>Ямал</li>
				<li>Валенки</li>
				<li>Гобелены</li>
				<li>Русские традиции</li>
				<li>Эльбрус</li>
				<li>Матрёшкин дом</li>
				<li>Суздаль</li>
				<li>Янтарь</li>
				<li>Ярославская майолика</li>
				<li>Елочка/Коробейник</li>
				<li>Ванильный крутиш</li>
				<li>Лакумы и пышки</li>
				<li>Ролл Дог и чай</li>
				<li>Тили тили тесто</li>
				<li>Платки и шали</li>
				<li>Камчатка</li>
				<li>Я люблю Москву</li>
				<li>Ладушки оладушки</li>
			</ol>

			<ol start="21">
				<li>Вафли и кофе</li>
				<li>Сладкий Чуророс</li>
				<li>Кренделя</li>
				<li>Пончики</li>
				<li>Ванильный крутиш</li>
				<li>HAPPY STORE</li>
				<li>Дымов</li>
				<li>Кузнецы</li>
				<li>Шашлык</li>
				<li>Гонконгские вафли</li>
				<li>Хот дог</li>
				<li>Кебаб</li>
				<li>Блины</li>
				<li>Бургер</li>
				<li>Самовар и пирожки</li>
				<li>Дымов</li>
				<li>Каштаны и кукуруза</li>
				<li>Леденцы</li>
				<li>Леденцы</li>
				<li>Каштаны и кукуруза</li>
			</ol>

			<ol start="41">
				<li>Горячие напитки</li>
				<li>Хохлома</li>
				<li>Сладкий Чуррос</li>
				<li>Русский пряник</li>
				<li>Палитра ремесел</li>
				<li>Блины</li>
				<li>Золотое руно</li>
				<li>Ванильный крутиш</li>
				<li>Пятигорская бронза</li>
				<li>Эвенкия</li>
				<li>Осетинские пироги</li>
				<li>Лакумы пышки</li>
				<li>Теплые вещи</li>
				<li>Каштаны и кукуруза</li>
				<li>Леденцы</li>
				<li>Каштаны и кукуруза</li>
				<li>Кузнецы</li>
			</ol>
		</div>
	</div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
	name: 'SectionMapYarmarka',
	data: () => ({
		ImageMap: require('@/assets/images/2023/map-yarmarka.png'),
	}),
});
</script>

<style lang="less" scoped>
.section-map {
	.legend {
		gap: 8px;

		& > div {
			flex: 1;
		}
		ol li {
			font-weight: bold;
			padding-left: 0.5rem;
		}
	}
}

@media (max-width: 599px) {
	.section-map {
		div {
			font-size: 12px;
		}
	}
}
</style>
